import { gql } from "@apollo/client";

export const MUTATION_REGISTER = gql`
  mutation register($input: UsersPermissionsRegisterInput!) {
    register(input: $input) {
      user {
        id
      }
    }
  }
`;
